module.exports = __webpack_public_path__ + "img/bicycleFrontRightOutline.0372167f.svg";